/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import Button from "components/CustomButtons/Button.js";
import * as typeAction from "../../../action/trajetAction";
import { InfoWindow, Polyline } from "@react-google-maps/api";
import moment from "moment";
import { tabColor } from "constance/constance";

/*
function generateRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

function generateUniqueColors(count) {
  const colorSet = new Set();
  while (colorSet.size < count) {
    colorSet.add(generateRandomColor());
  }
  return Array.from(colorSet);
}
*/
const TrajetPolyline = (props) => {
  const [positionTrajet, setPositionTrajet] = useState([]);
  const [tabPositionTrajet, setTabPositionTrajet] = useState([]);
  //const tabColor = generateUniqueColors(500);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [infoWindowPosition, setInfoWindowPosition] = useState(null);

  useEffect(() => {
    if (
      props.loadTrajetFromSaga.positionTotal !== undefined &&
      props.loadTrajetFromSaga.positionTotal !== null
    ) {
      const tabPosFilter = props.loadTrajetFromSaga.positionTotal.map((tab) => {
        const latLong = {
          ...tab,
          lat: Number(tab.latitude),
          lng: Number(tab.longitude),
        };
        return latLong;
      });
      setPositionTrajet(tabPosFilter);
    }

    //setPositionTrajet(tabPosFilter)
  }, [props.loadTrajetFromSaga?.positionTotal]);

  useEffect(() => {
    if (
      props.loadTrajetFromSaga.listTrajet !== undefined &&
      props.loadTrajetFromSaga.listTrajet !== null
    ) {
      const tableauDePositions = props.loadTrajetFromSaga.listTrajet.map(
        (trajet) =>
          trajet.positions.map((position) => ({
            lat: Number(position.latitude),
            lng: Number(position.longitude),
            adresseDepart: trajet.adresseDepart,
            adresseArrivee: trajet.adresseArrivee,
            heureDebut: trajet.heureDebut,
            heureFin: trajet.heureFin,
            dureeTrajet: trajet.dureeTrajet,
            distanceParcourue: trajet.distanceParcourue,
            ...position, // conserve les autres propriétés si nécessaire
          }))
      );

      //  console.log("dateReceptionPosition => ", tableauDePositions);
      setTabPositionTrajet(tableauDePositions);
    }

    //setPositionTrajet(tabPosFilter)
  }, [props.loadTrajetFromSaga?.listTrajet]);

  const handlePolylineClick = (position, event) => {
    console.log("handlePolylineClick => ", position);
    setSelectedPosition(position);
    setInfoWindowPosition({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
  };

  return (
    <>
      {/*
      <Polyline
        path={positionTrajet}
        options={{
          strokeColor: "#FFFFFF",
          strokeOpacity: 2,
          strokeWeight: 2.5,
        }}
      />
   */}

      {tabPositionTrajet?.map((pos, index) => {
        const getColor = () => {
          if (props.loadTrajetFromSaga.indexTrajetSelected !== -1) {
            if (props.loadTrajetFromSaga.indexTrajetSelected != index) {
              return "#878a8e";
            } else {
              return tabColor[index];
            }
          } else {
            return tabColor[index];
          }
        };

        return (
          <Polyline
            key={index}
            path={pos}
            options={{
              strokeColor: getColor(),
              strokeOpacity: 1,
              strokeWeight:
                props.loadTrajetFromSaga.indexTrajetSelected !== index ? 6 : 7,
            }}
            onClick={(event) => handlePolylineClick(pos, event)}
          />
        );
      })}
      {selectedPosition && infoWindowPosition && (
        <InfoWindow
          position={infoWindowPosition}
          onCloseClick={() => setSelectedPosition(null)}
        >
          <div>
            <h4>Trajet Détails</h4>
            <p>
              Heure Depart :{" "}
              {moment(selectedPosition[0]?.heureDebut).format(
                "DD-MM-YYYY HH:mm:ss"
              )}{" "}
            </p>
            <p>Adresse Depart: {selectedPosition[0]?.adresseDepart} </p>
            <p>
              Heure Arrive:{" "}
              {moment(selectedPosition[0]?.heureFin).format(
                "DD-MM-YYYY HH:mm:ss"
              )}{" "}
            </p>
            <p>Adresse Arrivee: {selectedPosition[0]?.adresseArrivee} </p>
            <p>Duree trajet: {selectedPosition[0]?.dureeTrajet} </p>
            <p>
              distanceParcourue: {selectedPosition[0]?.distanceParcourue} KM
            </p>

            {/* Ajoute plus de détails si besoin */}
          </div>
        </InfoWindow>
      )}
    </>
  );
};

const mapsStateToProps = (state) => {
  return {
    loadTrajetFromSaga: state.trajet,
    //  loadLecteurTrajetInfo: state.lecteurTrajet,
    //loadDateDyn: React.memo(()=> {state.dateDyn.compteur}, [])
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    loadTrajetDispatch: (data) => dispatch(typeAction.loadTrajetAction(data)),
    loadTrajetNewDispatch: (data) =>
      dispatch(typeAction.loadTrajetNewAction(data)),
    //playLecteurDispatch : () => dispatch(typeActionLecteur.playTrajetAction()),
    //pauseLecteurDispatch : () => dispatch(typeActionLecteur.pauseTrajetAction()),
    //stopLecteurDispatch : () => dispatch(typeActionLecteur.stopTrajetAction()),
  };
};

export default connect(mapsStateToProps, mapsDispatchToProps)(TrajetPolyline);
